module.exports = __webpack_public_path__ + "img/35912-077.3c31ebed.jpg";